/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

export interface IndustrySector {
  code: string,
  name: string,
  level: string,
}

export type RequireAtLeastOne<T> = {
  [K in keyof T]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<keyof T, K>>>;
}[keyof T];

export type DateRangeType = {
  startDate?: Date,
  endDate?: Date,
}

export type Country = { code: string, name: string };
export type CommonData = { countries: Country[] }

export enum OrderingDirection {
  Asc = 'asc',
  Desc = 'desc',
  Default = 'default',
}

export enum DisplayOption {
  MetricOverrides = 'displayMetricOverrides',
  UserInput = 'displayUserInput',
  SystemDefault = 'displaySystemDefault'
}

export enum DownloadUtrvStatusCombined {
  AllAnswered = 'allanswered',
  All = 'all',
  Assured = 'assured',
}

export enum OnboardingStep {
  Signup = 'Signup',
  VerifyEmail = 'VerifyEmail',
  CompanyInfo = 'CompanyInfo',
  SectorInfo = 'SectorInfo',
  ReportingCurrency = 'ReportingCurrency',
  ReferralInfo = 'ReferralInfo',
  Activation = 'Activation',
  Complete = 'Complete',
  EmailDomainCompanyOnboardOrNot = 'EmailDomainCompanyOnboardOrNot',

  // Referral+Lookup page for listed companies
  SGXReferrerCodeIssuerLookup = 'SGXReferrerCodeIssuerLookup',
  IssuerCompanyOnboardOrNot = 'IssuerCompanyOnboardOrNot',

  // Materiality assessment
  CompanyInfoMAT =  'CompanyInfoMAT',
  CreateAssessment = 'CreateAssessment',
  CompleteMAT = 'CompleteMAT',
}
